// REACT IMPORTS
import React from "react";

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import SendOtpForm from "components/auth/SendOtpForm";
import QuestionsFooter from "components/auth/QuestionsFooter";
import Helment from "components/layout/helmet";
import { TestIdScope } from "utils/testid";

/* ------------------------------------- SEND OTP ------------------------------------- */

const SendOtp = () => {
  return (
    <>
      <Helment />
      <TestIdScope scope="auth-send-otp">
        <div
          data-testid="auth-send-otp-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex lg:justify-center relative animate__animated animate__fadeIn lg:flex-row flex-col"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 h-full w-full flex flex-col items-center justify-between lg:overflow-y-auto">
            <div className="lg:pt-[134px] p-5 w-full flex justify-center">
              <SendOtpForm />
            </div>
            <div className={`pb-5 lg:pt-0 pt-4`}>
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default SendOtp;
